import { useProjectStore } from '@/core/project/store/project.store'

// Re-exporting the hook for backward compatibility
export const useWorkspace = useProjectStore

// Deprecated: for backward compatibility only if direct store access is needed
export const useWorkspaceStore = useProjectStore
